import Logo from "../../components/items/Logo"
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import AppContext from "../../context/AppContext";
import { useState, useRef, useContext } from "react";

function Verification() {
    const [code, setCode] = useState('');
    const [codeErr, setCodeErr] = useState('');
    const { goHome } = useContext(AppContext)
    const codeRef = useRef()

    const onSubmit = (e) => {
        e.preventDefault();
        setCodeErr('')
        codeRef.current.classList.remove('err')

        if(!code){
            setCodeErr('Please enter the 4-digit code')
            codeRef.current.classList.add('err')
        }

        if(code.length < 4){
            setCodeErr('Please enter the correct 4-digit code')
            codeRef.current.classList.add('err')
        }

        console.log({
            code
        })
        // setCode('')
    }

    const resendCode = () => {
        console.log("Sending a new code...")
    }

  return (
    <motion.main 
        className="user-form" 
        id="verify"
        initial={{width: 0}}
        animate={{width: '100%'}}
        exit={{x: window.innerWidth, transition: { duration: 0.1 }}}
    >
        <div className='medbolt-logo' onClick={goHome}>
            <Logo/>
        </div>
        <h1>Enter verification code</h1>
        <form noValidate onSubmit={onSubmit} className="verify">
            <p>
                We have sent a code to your email to verify that it is really you
            </p>
            <div className="user-input">
              <input ref={codeRef} type="text" maxLength="4" value={code} onChange={(e) => {setCode(e.target.value)}} required placeholder="Enter the 4 digit code"
                style={{marginBottom: !codeRef && '3rem'}}
              />
              <div className="error">{codeErr}</div>
            </div>
            <button className="trynow">Submit</button>
            <p className="no_code">Didn’t get an email?</p>
            <Link onClick={resendCode} className="link">Resend code</Link>
        </form>

    </motion.main>
  )
}

export default Verification